import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CategoryList from './category-list'

function CategoryLoadMore({ terms, pageSize }) {
  const [showPanel, setShowPanel] = useState(false)

  function togglePanel() {
    setShowPanel(!showPanel)
  }

  if (terms.length > 8) {
    const firstPage = terms.slice(0, pageSize)
    const nextPage = showPanel ? terms.slice(pageSize, terms.length) : []

    return (
      <div className="developer-search__toggle">
        <div className="developer-search__selection">
          <CategoryList terms={firstPage} />
          <CategoryList terms={nextPage} />
        </div>
        <button type="button" className="developer-search__toggle__button" onClick={togglePanel}>
          {`${showPanel ? 'Hide ' : 'Show all '}`}
          {terms[0].taxonomy}s
        </button>
      </div>
    )
  }

  return (
    <div className="developer-search__selection">
      <CategoryList terms={terms} />
    </div>
  )
}

CategoryLoadMore.propTypes = {
  terms: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
}

CategoryLoadMore.defaultProps = {
  pageSize: 8,
}

export default CategoryLoadMore
